export const categories = [
  { id: 'ceiling', label: 'Ceiling' },
  { id: 'drywall', label: 'Drywall & Partitioning' },
  { id: 'plasters', label: 'Plasters' },
  { id: 'insulation', label: 'Insulation' },
  { id: 'acoustic', label: 'Acoustic' },
  { id: 'accessories', label: 'Tools & Fasteners' },
  { id: 'access', label: 'Ladders & Door Frames' },
];
